import template from './openBankingLiabilities.template.html';

export default {
  template,
  bindings: {
    data: '<',
    contacts: '<',
    assets: '<',
    onChange: '&'
  },
  controller: class controller {
    constructor($rootScope, listServiceNew, LiabilityType, AssetType) {
      'ngInject';

      const ctrl = this;
      ctrl.currentCurrency = null;
      ctrl.list = new listServiceNew.List();
      ctrl.list.clear();

      ctrl.initialize = () => {
        ctrl.currentCurrency = $rootScope.CurrentCurrency();
        ctrl.data = ctrl.data || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.assets = ctrl.assets || [];
        ctrl.list.setData(ctrl.data);
        ctrl.list.deselectedData(ctrl.list.getSelected());
      };

      ctrl.hasRealEstateAsset = () =>
        _.some(
          ctrl.assets || [],
          (a) =>
            a?.assetType?.name === AssetType.owner_occupier_property_address.name ||
            a?.assetType?.name === AssetType.investment_property_address.name
        );

      ctrl.hasMortgageLiability = () =>
        _.some(
          ctrl.data?.liabilities || [],
          (l) => l?.liabilityType?.mortgage_loan?.name === LiabilityType.mortgage_loan.name
        );

      ctrl.canSelect = (item) => {
        if (item?.liabilityType?.name === LiabilityType.mortgage_loan.name) {
          return ctrl.hasRealEstateAsset();
        }
        return true;
      };

      ctrl.getContactName = (ownership) => {
        const contact = _.find(ctrl.contacts || [], (c) => c?.id === ownership[0].idContact);
        return contact?.getName() || 'N/A';
      };

      ctrl.select = (data) => {
        const filteredData = [];
        const len = data?.length || 0;
        for (let l = 0; l < len; l += 1) {
          if (data[l]?.liabilityType?.name !== LiabilityType.mortgage_loan.name) {
            filteredData.push(data[l]);
          }
          if (
            ctrl.hasRealEstateAsset() &&
            data[l]?.liabilityType?.name === LiabilityType.mortgage_loan.name
          ) {
            filteredData.push(data[l]);
          }
        }
        ctrl.list.setSelected(filteredData);
        ctrl.onChange({ data: ctrl.list.getSelected() });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
